import { createUserWithEmailAndPassword, GoogleAuthProvider, signInWithEmailAndPassword, signInWithPopup } from "firebase/auth"
import { useState } from "react"
import { auth, checkIfUserExists, createUserDocument } from "../../firebase"
import "./create-account.css"

export default function CreateAccount () {

    const [email, setEmail] = useState("")
    const [password, setPassword] = useState("")
    const [nickname, setNickname] = useState("")

    const [error, setError] = useState("")

    const handleSubmit = (e) => {
        e.preventDefault();
        createUserWithEmailAndPassword(auth, email, password).then((result) => {
            return createUserDocument(result.user, { nickname });
        }).then(() => {
            window.location.reload();
        }).catch((error) => {
            if (error.code === "auth/weak-password") {
                setError("Password shoule be at least 6 characters")
            } else if (error.code === "auth/email-already-in-use") {
                setError("This email address is already in use")
            }
        });
    };

    const handleGoogle = async () => {
        try {
            const result = await signInWithPopup(auth, new GoogleAuthProvider());
            const user = result.user;

            const exists = checkIfUserExists(user)

            if (!exists) {
                await createUserDocument(user, { 
                    nickname: user.email.split("@")[0] 
                });
            }

        } catch (error) {
            setError("An error occurred when signing in with Google");
            console.error(error);
        }
    };


    return <div id="create-account">
        <form className="account-form" onSubmit={(e) => handleSubmit(e)}>
            <div className="form-field">
                <label htmlFor="email">Nickname*</label>
                <input type="text" name="nickname" onChange={(e) => setNickname(e.target.value)} required />
            </div>
            <div className="form-field">
                <label htmlFor="email">Email address*</label>
                <input type="email" name="email" onChange={(e) => setEmail(e.target.value)} required />
            </div>
            <div className="form-field">
                <label htmlFor="password">Password*</label>
                <input type="password" name="password" onChange={(e) => setPassword(e.target.value)} required />
            </div>

            {error != "" && <div className="error-field"> {error} </div>}

            <input className="form-submit" type="submit" value="Create an account" />
        </form>

        <hr />

        <div className="google-button" onClick={() => handleGoogle()}>
            <img src={`${process.env.PUBLIC_URL}/assets/Google_Favicon_2025.svg.png`} alt="user" height="30" width="30" />
            Log in with your Google Account
        </div>
    </div>
}